import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockRssIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockRss",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.97 24.75V7.25A5.31 5.31 0 0 0 24.74 2H7.24C4.36 2.04 2.03 4.37 2 7.24v17.51A5.3 5.3 0 0 0 7.24 30h17.51A5.3 5.3 0 0 0 30 24.76s-.03 0-.03 0Zm-20.77.64c-1.41 0-2.56-1.14-2.56-2.56s1.14-2.56 2.56-2.56 2.56 1.14 2.56 2.56c0 1.41-1.14 2.56-2.56 2.56m8.48-1.36c-.61 0-1.11-.5-1.11-1.11 0-4.1-3.32-7.42-7.42-7.42-.61 0-1.11-.5-1.11-1.11s.5-1.11 1.11-1.11c5.31 0 9.62 4.31 9.63 9.63v.02c0 .6-.47 1.08-1.06 1.11h-.03Zm7.42 0c-.61 0-1.11-.5-1.11-1.11 0-8.2-6.65-14.84-14.84-14.84-.61 0-1.11-.5-1.11-1.11s.5-1.11 1.11-1.11h.03c9.43 0 17.08 7.64 17.09 17.07 0 .62-.5 1.11-1.11 1.11h-.05Z"
    })
  }));
};
SocialBlockRssIcon.displayName = 'SocialBlockRssIcon';